import "@babel/polyfill";
import "current-script-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "@/plugins/i18n";
import moment from "moment";
import store from "@/vuex/store";
import btoa from "btoa";
import VueJWT from "vuejs-jwt";
import VueGtm from "vue-gtm";
import VeeValidate from "vee-validate";
import VCalendar from "v-calendar";

import PortalVue from "portal-vue";
// import CKEditor from 'ckeditor';
import AsyncComputed from "vue-async-computed";
import { VueReCaptcha } from "vue-recaptcha-v3";
import browserDetect from "vue-browser-detect-plugin";
import sanitizeHTML from 'sanitize-html';

//Zetech web components
import {
  ztBreadcrumbs,
  ztIcon,
  ztTooltip,
  ztTable,
  ztInput,
  ztCheckBox,
  ztSelect,
  ztChip,
  ztSwitch,
  ztButton,
  ztAlert,
  ztModal,
  ztOverlay,
  ztAutocomplete,
  ztDropdown,
  ztAvatar,
  ztRadioButton,
  ztBadge,
  ztPdfViewer,
  ztInputFile,
  ztSizeProvider,
  ztTab,
  ztDataTable,
  ztAccordion
} from "@zetech/ui-elements";
// add css for styles components;
import "@zetech/ui-elements/dist/ztelements.css";

// Import component
import VueLoading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

declare global {
  interface Window {
    wootric?: any;
    wootric_no_surveyed_cookie?: any;
    wootricSettings?: any;
  }
}

Vue.component('VueLoading', VueLoading)

const strings = {
  es: {
    email: (field) => `El campo ${field} debe ser un email valido.`,
    required: (field) => `Este campo es requerido.`,
    min: (field, min) => ` La cantidad mínima de caracteres son ${min}`,
    max: (field, max) => ` La cantidad máxima de caracteres son ${max}`,
    confirmed: (field) => `Las contraseñas no coinciden`,
    numeric:(field) => `El campo debe ser numérico`,
    regex: (field) => {
      if(field === 'usuario') {
        return 'El campo sólo permite caracteres alfanuméricos y guión bajo'
      }
      return 'No están permitidos los caracteres especiales'
    }
  },
};

Vue.use(VueGtm, {
  id: window.trcb.gtmId, // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

Vue.use(VeeValidate, {
  locale: "es",
  dictionary: {
    es: { messages: strings.es },
  },
});

Vue.use(VueReCaptcha, {
  siteKey: window.trcb.recaptchaKey,
  loaderOptions: {
    autoHideBadge: true,
  },
});

Vue.use(PortalVue);
// Vue.use( CKEditor );
Vue.use(AsyncComputed);
Vue.use(browserDetect);

//use zetech web component
Vue.use(ztBreadcrumbs);
Vue.use(ztIcon);
Vue.use(ztTooltip);
Vue.use(ztTable);
Vue.use(ztInput);
Vue.use(ztCheckBox);
Vue.use(ztSelect);
Vue.use(ztChip);
Vue.use(ztSwitch);
Vue.use(ztButton);
Vue.use(ztAlert);
Vue.use(ztModal);
Vue.use(ztOverlay);
Vue.use(ztAutocomplete);
Vue.use(ztDropdown);
Vue.use(ztAvatar);
Vue.use(ztRadioButton);
Vue.use(ztInputFile);
Vue.use(ztBadge)
Vue.use(ztPdfViewer)
Vue.use(ztInputFile)
Vue.use(ztSizeProvider)
Vue.use(ztTab)
Vue.use(ztDataTable)
Vue.use(ztAccordion)

Vue.use(VCalendar);

Vue.use(VueJWT, { keyName: "jwt" });

// Vue.component('ElementLoading', ElementLoading);
Object.defineProperty(Vue.prototype, "btoa", { value: btoa });

Vue.config.productionTip = false;

Vue.filter("estatus", function(value) {
  return value == "true" ? (value = "Activo") : (value = "Inactivo");
});

Vue.filter("formatDate", function(value) {
  if (value) {
    moment.locale("es");
    return moment(value, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]").fromNow();
  }
});

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString().toLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("avatarname", function(value) {
  if (!value) return "";
  value = value.toString().toLowerCase();
  return value.charAt(0).toUpperCase();
});

Vue.prototype.$sanitize = sanitizeHTML;

new Vue({
  router,
  render: (h) => h(App),
  i18n,
  store,
}).$mount("#app");
